export default __webpack_public_path__ + "static/media/apple-watch.e3398ca8.png";